import React, { useState, useEffect, Fragment } from 'react';
import { AllowedGuard } from 'components/Tvendo/Common/UserAction';
import { ConstantPermissions } from 'contexts/useConstant';

import { makeStyles } from '@material-ui/core/styles';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';

import { Assignment } from '@material-ui/icons';

import GridItem from 'components/Grid/GridItem.js';
import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import CardIcon from 'components/Card/CardIcon.js';
import CardHeader from 'components/Card/CardHeader.js';
import ReactTable from 'components/ReactTable/ReactTable.js';

import { wsFindBy } from 'services/WService';
import { WithApp } from 'contexts/appContext';

const useStyles = makeStyles({
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px'
  }
});

const columns = [
  { Header: '#', accessor: 'num', excelEnabled: false, width: 80 },
  { Header: 'T. Doc Sun.', accessor: 'DocSubDescription', width: 110 },
  { Header: 'Tipo Ing.', accessor: 'DocType', width: 100 },
  { Header: 'Serie Doc.', accessor: 'U_SYP_MDSD', width: 100 },
  { Header: 'Corr. Sun.', accessor: 'U_SYP_MDCD', width: 100 },
  { Header: 'Num. SAP', accessor: 'DocNum', width: 100 },
  { Header: 'Esta. Doc.', accessor: 'DocStatus', width: 100 },
  { Header: 'Cancelado', accessor: 'CANCELED', width: 100 },
  { Header: 'Fec. Cont.', accessor: 'DocDate', width: 100 },
  { Header: 'Fec. Vto.', accessor: 'DocDueDate', width: 100 },
  { Header: 'Fec. Doc.', accessor: 'TaxDate', width: 100 },
  { Header: 'Fec. Canc.', accessor: 'CancelDate', width: 100 },
  { Header: 'Vendedor', accessor: 'SlpName', width: 300 },
  { Header: 'Dirección', accessor: 'Address', width: 300 },
  { Header: 'Dirección 2', accessor: 'Address2', width: 300 },
  { Header: '% Dsct.', accessor: 'DiscPrcnt', width: 100 },
  { Header: 'Total Doc.', accessor: 'DocTotal', width: 100 },
  { Header: 'Pagado', accessor: 'PaidToDate', width: 100 },
  { Header: '', accessor: 'actions', excelEnabled: false, width: 0 }
];

export default WithApp(function CreditNote(props) {
  const classes = useStyles();

  const [creditNote, setCreditNote] = useState([]);

  async function listCreditNotes() {
    let response = await wsFindBy(
      'sap/business-partner/credit-note',
      'CardCode',
      props.businessPartner.CardCode
    );
    if (response.success) setCreditNote(response.data);
  }

  useEffect(() => {
    listCreditNotes();
  }, []);
  return (
    <Fragment>
      <GridItem xs={12}>
        <Card>
          <CardHeader icon>
            <CardIcon color={props.themeContext.buttonColor}>
              <Assignment />
            </CardIcon>
            <h4 className={classes.cardIconTitle}>Listado de notas de crédito</h4>
          </CardHeader>
          <CardBody>
            <ReactTable
              formatDate="YYYY-MM-DD"
              excelName="Notas-de-créditos"
              defaultWidth={2400}
              columns={columns}
              data={creditNote.map((item, i) => {
                return {
                  num: i + 1,
                  DocSubDescription: item.DocSubDescription, //DocSubType
                  DocType: item.DocType === 'I' ? 'Artículo' : 'Servicio',
                  U_SYP_MDSD: item.U_SYP_MDSD,
                  U_SYP_MDCD: item.U_SYP_MDCD,
                  DocNum: item.DocNum,
                  DocStatus: item.DocStatus === 'O' ? 'Abierto' : 'Cerrado',
                  CANCELED: item.CANCELED === 'Y' ? 'Si' : 'No',
                  DocDate: item.DocDate,
                  DocDueDate: item.DocDueDate,
                  TaxDate: item.TaxDate,
                  CancelDate: item.CancelDate,
                  SlpName: item.SlpName,
                  Address: item.Address,
                  Address2: item.Address2,
                  DiscPrcnt: item.DiscPrcnt,
                  DocTotal: item.DocTotal,
                  PaidToDate: item.PaidToDate,
                  actions: ''
                };
              })}
            />
          </CardBody>
        </Card>
      </GridItem>
    </Fragment>
  );
});
